import Swiper from 'swiper/bundle';

export default function initializeSlider50() {
    document.querySelectorAll('.slider-50__swiper-container').forEach(item => {
        const parent = item.closest('.block-slider-50');

        const swiper = new Swiper(item, {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 24,
            speed: 500,
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: false,
            pagination: {
                el: parent.querySelector('.block-slider-50__pagination'),
                loop: true,
                clickable: true,
                bulletClass: "slider-pagination__bullet",
                bulletActiveClass: "slider-pagination__bullet--active",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            }
        });
    });
}